import { Box, Typography, Divider } from "@mui/material";


// FILETRS
const FILTER_INFORMATION_DETAILS = [
    {
        title: "Filters Information",
        info: [
            "Company: Select one or more companies",
            "Region: Filter stores by region",
            "Store: Select one or multiple stores. Stores options adjust automatically based on selected company and region.",
            "Category: Choose among Imported Fruits, Local",
            // "No. of SKUs: Show Top 20, Top 50, or All SKUs based on sales ranking.",
            // "Period of Observation: Select a time window for analysis"
        ],
        // sub_info: [
        // "3 Days: Shows unaggregated daily data (hour-by-hour view).",
        // "7 Days / 30 Days /YTD: Aggregated across the selected period.",
        // ],
        detail: "Click Apply Filters to update your view. Applied filters are summarized at the top of the dashboard."
    }
]

export const FilterInformationContent = FILTER_INFORMATION_DETAILS.map((section, index) => (
    <Box key={index}>
        <Typography variant="body1" fontWeight="bold" my={0.5} mt={index === 0 ? 0 : 2}>{section.title}</Typography>
        <Divider sx={{ borderBottomWidth: '2px', backgroundColor: '#000' }} />

        <Box component="ul" sx={{ pl: 3, mt: 1 }}>
            {section.info.map((info, i) => {
                const idx = info.indexOf(":");
                if (idx !== -1) {
                    const left = info.slice(0, idx).trim();
                    const right = info.slice(idx + 1).trim();
                    return (
                        <li key={i}>
                            <span style={{ fontWeight: 'bold' }}>{left}:</span> <span>{right}</span>
                        </li>
                    );
                }
                return <li key={i}>{info}</li>;
            })}
        </Box>

        {section.sub_info && section.sub_info.length > 0 && (
            <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                {section.sub_info.map((s, si) => {
                    const idx = s.indexOf(":");
                    if (idx !== -1) {
                        const left = s.slice(0, idx).trim();
                        const right = s.slice(idx + 1).trim();
                        return (
                            <li key={si}>
                                <span style={{ fontWeight: 'bold' }}>{left}:</span> <span>{right}</span>
                            </li>
                        );
                    }
                    return <li key={si}>{s}</li>;
                })}
            </Box>
        )}

        {section.detail && (
            <Box component="div" sx={{ mt: 1 }}>
                <Typography variant="body2" component="span">
                    {(() => {
                        const boldText = "Apply Filters";
                        if (!section.detail.includes(boldText)) return section.detail;
                        const parts = section.detail.split(boldText);
                        return (
                            <>
                                <span>{parts[0]}</span>
                                <strong>{boldText}</strong>
                                <span>{parts[1]}</span>
                            </>
                        );
                    })()}
                </Typography>
            </Box>
        )}
    </Box>
))


// TABLE
const TABLE_INFORMATION_DETAILS = [
    {
        title: "How to Read:",
        info: [
            "Rows: Articles displayed based on the selected filters.",
            "Columns: Hours of the day (08:00–22:00) displayed in 24-hour format.",
            "'❌' markers: Hours when the article is likely out of stock (OOS)",
            "OOS %: Percentage of hours the article is flagged as OOS within the day.",
            "\n",
            "Note: Hover over a cell to view the sales value for that hour (if this option is enabled)."
        ]
    }
];

export const TableInformationContent = TABLE_INFORMATION_DETAILS.map((section, index) => (
    <Box key={index}>
        <Typography variant="body1" fontWeight="bold" my={0.5} mt={index === 0 ? 0 : 2}>
            {section.title}
        </Typography>
        <Divider sx={{ borderBottomWidth: "2px", backgroundColor: "#000" }} />

        <Typography variant="body2">
            {section.info.map((info, i) => {
                const NEXT_LINE_TEXT = "\n";
                const NOTE_TEXT = "Note:";
                const IF_TEXT = "(if this option is enabled)";
                const SALES_TEXT = "sales value";

                if (info.trim() === NEXT_LINE_TEXT) {
                    return <br key={i} paddingTop={20} />;
                }

                if (info.startsWith(NOTE_TEXT)) {
                    const hasIf = info.includes(IF_TEXT);
                    const withoutIf = info.replace(IF_TEXT, "").trim();

                    const salesRegex = new RegExp(`(${SALES_TEXT})`, "i");
                    const segments = withoutIf.split(salesRegex);

                    return (
                        <div key={i}>
                            {segments.map((seg, si) =>
                                seg.toLowerCase() === SALES_TEXT
                                    ? <strong key={si}>{seg}</strong>
                                    : <span key={si}>{seg}</span>
                            )}
                            {hasIf && <em style={{ marginLeft: 4 }}>{IF_TEXT}</em>}
                        </div>
                    );
                }

                if (!info.trim()) {
                    return <br key={i} style={{ marginBottom: 8 }} />;
                }

                if (info.includes(":")) {
                    const parts = info.split(":");

                    const part1 = parts[1].replace(IF_TEXT, "").trim();
                    const hasIf = parts[1].includes(IF_TEXT);

                    return (
                        <div key={i}>
                            <span style={{ fontWeight: "bold" }}>{parts[0]}</span>: {part1}
                            {hasIf && <em style={{ marginLeft: 4 }}>{IF_TEXT}</em>}
                        </div>
                    );
                }

                const hasIf = info.includes(IF_TEXT);
                const withoutIf = hasIf ? info.replace(IF_TEXT, "").trim() : info;

                const salesRegex = new RegExp(`(${SALES_TEXT})`, "i");
                const segments = withoutIf.split(salesRegex);

                return (
                    <div key={i}>
                        {segments.map((seg, si) =>
                            seg.toLowerCase() === SALES_TEXT
                                ? <strong key={si}>{seg}</strong>
                                : <span key={si}>{seg}</span>
                        )}
                        {hasIf && <em style={{ marginLeft: 6 }}>{IF_TEXT}</em>}
                    </div>
                );
            })}
        </Typography>
    </Box>
))



// DASHBOARD
const DASHBOARD_INFORMATION_DETAILS = [
    {
        title: "OOS Explainer",
        info: [
            "Out-of-stock (OOS) status is evaluated hourly based on Markets POS sales data.",
            "An article is flagged as OOS (“❌”) when there are no recorded sales for three consecutive hours,",
            "-indicating the product was likely unavailable on shelf."
        ],
        sub_title: "Simplified Logic:",
        sub_info: [
            "When this happens, the first hour in that three-hour window is marked as OOS.",
            "If the previous hour is already OOS and the current hour still has zero sales, the OOS status continues.",
            "If there are sales in the hour, the cell remains blank (assumed in stock).",
            "For the last hour of the day (9 PM–10 PM), OOS is applied if no sales are recorded from 8 PM–10 PM."
        ]
    }
]


export const DashboardInformationContent = DASHBOARD_INFORMATION_DETAILS.map((section, index) => {
    const infoHighlights = ["OOS (“❌”)", "no sales", "no recorded sales for three consecutive hours"];
    const infoPattern = new RegExp(`(${infoHighlights.map(w => w.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")).join("|")})`, "ig");

    const subInfoHighlights = ["no sales for 3 consecutive hours", "last hour of the day (9 PM–10 PM)", "blank", "previous hour is already OOS", "first hour", "0,", "current hour still has zero sales", "no sales are recorded from 8 PM–10 PM"];
    const subInfoPattern = new RegExp(`(${subInfoHighlights.map(w => w.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")).join("|")})`, "ig");

    const renderWithHighlights = (text, isSubInfo = false) =>
        String(text)
            .split(isSubInfo ? subInfoPattern : infoPattern)
            .map((part, i) =>
                (isSubInfo ? subInfoPattern : infoPattern).test(part) ? <strong key={i}>{part}</strong> : <span key={i}>{part}</span>
            );

    return (
        <Box key={index}>
            <Typography variant="body1" fontWeight="bold" my={0.5} mt={index === 0 ? 0 : 2}>{section.title}</Typography>
            <Divider sx={{ borderBottomWidth: '2px', backgroundColor: '#000' }} />

            <Box component="div" sx={{ mt: 1 }}>
                {section.info.map((info, i) => (
                    <Typography variant="body2" key={i} sx={{ mb: 0.5 }}>
                        {renderWithHighlights(info, false)}
                    </Typography>
                ))}
            </Box>
            <Typography variant="body1" fontWeight="bold" my={0.5} mt={1}>{section.sub_title}</Typography>

            {section.sub_info && section.sub_info.length > 0 && (
                <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                    {section.sub_info.map((s, si) => (
                        <li key={si}>
                            <Typography variant="body2" component="span">
                                {renderWithHighlights(s, true)}
                            </Typography>
                        </li>
                    ))}
                </Box>
            )}
        </Box>
    );
})